export default __webpack_public_path__ + "static/media/Human2.bac30eeb.png";